<template>
  <div>
    <!-- <v-dialog
      v-model="show"
      v-if="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-progress-linear
            :indeterminate="true"
            class="ma-0"
            :active="iframeLoaded"
            v-if="iframeLoaded"
          ></v-progress-linear>
          <v-toolbar dark color="primary" dense>
            <slot></slot>
            <v-toolbar-title>{{title}}</v-toolbar-title>
          </v-toolbar>
          <iframe :src="src" @load="load"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>-->
    <v-progress-linear
      :indeterminate="true"
      class="ma-0"
      :active="iframeLoaded"
      v-if="iframeLoaded"
    ></v-progress-linear>
    <iframe :src="src" @load="load"></iframe>
  </div>
</template>
<script>
import { mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import { isNullOrUndefined } from "../../validation/validation";
export default {
  data: () => ({
    //src: "https://localhost:44355/ReportViewer.aspx",
    iframeLoaded: false,
    dialog: true,
    src: "",
  }),
  computed: {
    ...mapState("report", {
      url: (state) => state.url,
    }),
  },
  methods: {
    load() {
      this.iframeLoaded = false;
    },
    printResume(empCode) {
      this.$axios
        .get(`/api/manpower/print/${empCode}`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            this.src = data.url;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    previewPR(prfNo) {
      this.$axios
        .get(`/api/pr/preview/${prfNo}`)
        .then(({ data }) => {
          this.src = data;
          //console.log(sha256(data));
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    previewEC(ecfNo) {
      this.$axios
        .get(`/api/empClearance/preview/${ecfNo}`)
        .then(({ data }) => {
          this.src = data;
          //console.log(sha256(data));
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    doleRoster() {},
  },
  created() {
    let { type, reportCode } = this.$route.query;
    if (type == "resume") {
      if (!isNullOrUndefined(this.$route.query.empCode))
        this.printResume(this.$route.query.empCode);
    }

    if (type == "pr-preview") {
      let { prfNo } = this.$route.query;
      this.previewPR(prfNo);
    }

    if (type == "ec-preview") {
      let { ecfNo } = this.$route.query;
      this.previewEC(ecfNo);
    }

    if (
      reportCode == "004" ||
      reportCode == "001" ||
      reportCode == "002" ||
      reportCode == "003" ||
      reportCode == "005"
    ) {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (reportCode == "006") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "007") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "008") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        paramKey,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&paramKey=${paramKey}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "009") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }


    if (reportCode == "011") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "012") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "014") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }
    if (reportCode == "015") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (reportCode == "016") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (reportCode == "017") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (reportCode == "018") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (
      reportCode == "010" ||
      reportCode == "013" ||
      reportCode == "019" ||
      reportCode == "020" ||
      reportCode == "021" ||
      reportCode == "022" ||
      reportCode == "023" ||
      reportCode == "023-2" ||
      reportCode == "023-3" ||
      reportCode == "024" ||
      reportCode == "025" ||
      reportCode == "026" ||
      reportCode == "027" ||
      reportCode == "028" ||
      reportCode == "029" ||
      reportCode == "030" ||
      reportCode == "031" ||
      reportCode == "032" ||
      reportCode == "033" ||
      reportCode == "034" ||
      reportCode == "035" ||
      reportCode == "036" ||
      reportCode == "038" ||
      reportCode == "039" ||
      reportCode == "040" ||
      reportCode == "043" ||
      reportCode == "044" ||
      reportCode == "045" ||
      reportCode == "046" ||
      reportCode == "047" ||
      reportCode == "048" ||
      reportCode == "049" ||
      reportCode == "050" ||
      reportCode == "051" ||
      reportCode == "052" ||
      reportCode == "054" ||
      reportCode == "056" ||
      reportCode == "057" ||
      reportCode == "058" ||
      reportCode == "059" ||
      reportCode == "060" ||
      reportCode == "061" ||
      reportCode == "062" ||
      reportCode == "063" ||
      reportCode == "064" ||
      reportCode == "065" ||
      reportCode == "066" ||
      reportCode == "067" ||
      reportCode == "068" ||
      reportCode == "069" ||
      reportCode == "070" ||
      reportCode == "071" ||
      reportCode == "072" ||
      reportCode == "073" ||
      reportCode == "074" || 
      reportCode == "075" ||
      reportCode == "076" ||
      reportCode == "077" ||
      reportCode == "078" ||
      reportCode == "079" ||
      reportCode == "080" ||
      reportCode == "081" ||
      reportCode == "082" ||
      reportCode == "083" ||
      reportCode == "084" ||
      reportCode == "085" ||
      reportCode == "086" ||
      reportCode == "087" ||
      reportCode == "088" ||
      reportCode == "089" ||
      reportCode == "090" ||
      reportCode == "091" ||
      reportCode == "092" ||
      reportCode == "093" ||
      reportCode == "094" ||
      reportCode == "095" ||
      reportCode == "096" ||
      reportCode == "097" ||
      reportCode == "098" ||
      reportCode == "099" ||
      reportCode == "100" 
    ) {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        logoWidth,
        logoAlign,
        rpt,
        paramKey,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&logoAlign=${logoAlign}&logoWidth=${logoWidth}&rpt=${rpt}&paramKey=${paramKey}`;
    }

    if (reportCode == "pme") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        print,
        rpt,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&print=${print}&rpt=${rpt}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "pme-woallo" || reportCode == "SM" || reportCode == "MI") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        print,
        rpt,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&print=${print}&rpt=${rpt}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "emp-only") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        print,
        rpt,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&print=${print}&rpt=${rpt}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }

    if (reportCode == "allowance") {
      let {
        dbName,
        key,
        companyKey,
        reportUrl,
        reportCode,
        client,
        print,
        rpt,
        logoWidth,
        logoAlign,
      } = this.$route.query;
      this.src = `${reportUrl}?reportCode=${reportCode}&dbName=${dbName}&key=${key}&companyKey=${companyKey}&client=${client}&print=${print}&rpt=${rpt}&logoAlign=${logoAlign}&logoWidth=${logoWidth}`;
    }
  },
  mounted() {
    this.iframeLoaded = true;
  },
};
</script>
<style scoped>
iframe {
  display: block; /* iframes are inline by default */
  border: none; /* Reset default border */
  height: 100vh; /* Viewport-relative units */
  width: 100vw;
}
</style>
